// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionI_comp__DAdt1","section":"SectionI_section__StHY_","graphic":"SectionI_graphic__hfCoF"};